module.exports = __webpack_public_path__ + "b7c970e182e2d13f7f34c04b654a598d.svg";